// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__Mqq8x","list":"Projects_list__PABFC"};